
import { Vue, Options } from 'vue-class-component';

@Options({
	name: 'DraftLayout',
})
export default class DraftLayout extends Vue {}
